import CanvasSettings from '../../../chartSettings/canvasSettings'

type Props = {
    viewKey: string
}

const MultiStrikeCanvasSettings = ({ viewKey }: Props) => (
    <CanvasSettings viewKey={viewKey} useMultiStrikeStorage />
)

export default MultiStrikeCanvasSettings
